import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Wrapper } from 'modules/theme';
import SettingsSidebar from '../../sidebar';
import { Row, RowTitle, Box, BoxName, Divider } from '../styles';
import { SettingTheme } from 'modules/theme';
import { transparent } from '../../../../../helpers/dotenv';

class Settings extends Component {
  renderBox(name, image, to, block) {
    const { __ } = this.context;
    return (
      <Box>
        <Link
          style={!block ? {} : { cursor: 'not-allowed' }}
          to={!block ? to : '#'}
        >
          <img src={image} alt={name} />
          <BoxName>{__(name)}</BoxName>
        </Link>
      </Box>
    );
  }

  render() {
    const { __ } = this.context;

    return <SettingTheme />;
  }
}

Settings.contextTypes = {
  __: PropTypes.func
};

export default Settings;



// WEBPACK FOOTER //
// src/modules/screens/settings/main/components/Settings.js